import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import smartCitiesImage from './images/cities.png';
import environmentalImage from './images/environmental.png';
import greensupplyImage from './images/greensupply.png';
import mobileAppsImage from './images/mobile.png';
import './style.css';

const options = [
  { value: 'smart-cities', label: 'Smart Cities', image: smartCitiesImage },
  { value: 'environmental-regulations-planing', label: 'Environmental Regulation & Planning', image: environmentalImage },
  { value: 'green-supply-chain', label: 'Green Supply Chain', image: greensupplyImage },
  { value: 'mobile-apps', label: 'Mobile apps', image: mobileAppsImage }
];


class HomeDiscover extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedSection: props.selectedSection
    };
  }

  onSectionChange(selectedSection) {
    this.setState({ selectedSection });
  }

  render() {
    const { selectedSection } = this.state;

    return (
      <div className="home-discover">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-3">
              <div className="-image">
                <div className="home-discover-img">
                  <img src={selectedSection.image} alt={selectedSection.label} />
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-9">
              <div className="home-discover-description">
                <div className="rectangle" />
                <h2>Discover what&#39;s possible</h2>

                <Select
                  classNamePrefix="react-select"
                  value={selectedSection}
                  options={options}
                  onChange={e => this.onSectionChange(e)}
                />

                <div className="home-discover-content">
                  {selectedSection.value === 'smart-cities' && (
                    <Fragment>
                      <p className="-intro intro-main">Manage emission sources to reduce the economic and societal impact of pollution.</p>
                      <p>Our Decision Supporting Tool simulates air quality scenarios to evaluate the impact of the actions helping to develope a smart city plan.</p>
                      <p>Air Quality information is used to manage assets and resources efficiently to become a smart city, facing the increasing levels of air pollution. A sustainable economic development and a high quality of life are the current challenges.</p>
                    </Fragment>
                  )}
                  {selectedSection.value === 'mobile-apps' && (
                    <Fragment>
                      <p className="-intro">High quality and globally available Air Quality datasets to make your app stand out from the crowd.</p>
                      <p>The best way to find out about the latest air quality inputs for a less exposure to high levels of pollution.</p>
                      <p>A 3 days in advance hourly forecast in a high quality performance among other products will distinguish your Air Quality, Weather and fitness Mobile Application.</p>
                    </Fragment>
                  )}
                  {selectedSection.value === 'environmental-regulations-planing' && (
                    <Fragment>
                      <p className="-intro">Strategic planning for a higher resilience</p>
                      <p>Environment Regulation and Planning Authority has the role of reporting air quality measurements, impose taxes to companies exceeding the defined thresholds, alert the public of air pollution incidents, and take appropriate actions to mitigate them.</p>
                      <p>With our 4 products, we help developing an air quality strategic plan to reduce levels of pollutants in cities. A monthly detailed estimate of air emissions, hourly high resolution maps of urban air pollution, a 3 days in advance hourly forecast in a high quality performance and our decision supporting tool for simulating air quality scenarios to evaluate the impact of the actions can help governments to improve the quality of the air.</p>
                    </Fragment>
                  )}
                  {selectedSection.value === 'green-supply-chain' && (
                    <Fragment>
                      <p className="-intro">Data from satellites, visualization & analysis for informed decisions</p>
                      <p>Identifying the location and spatial extent of emissions hotspots is crucial for targeting cleanup efforts.</p>
                      <p>Track pollution created by supply chains. Identifying all actors along the supply chain whose activities contribute to emission hotspots can open the door to new solutions to fight pollution.</p>
                      <p>Databases can be used to identify key flows and industries in supply networks that contribute to the air pollution footprint.</p>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HomeDiscover.propTypes = {
  selectedSection: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string
  })
};

HomeDiscover.defaultProps = {
  selectedSection: options[0]
};

export default HomeDiscover;



// WEBPACK FOOTER //
// ./src/pages/home/home-discover/index.js